module.exports = __webpack_public_path__ + "static/media/a1.f8d0c931.jpg";